import { objectAssign } from '@dazn/peng-html5-tools-utils';
import { MessageType } from "../Constants/MessageType";
var declareFeatureMessages = function () {
    var _a;
    var messages = (_a = {},
        _a[MessageType.INFO] = {},
        _a[MessageType.LOG] = {},
        _a[MessageType.WARNING] = {},
        _a[MessageType.ERROR] = {},
        _a);
    var usedIds = {};
    var createMessageAssignerOfType = function (messageType) {
        return function (m) {
            var _a;
            if ("undefined" === 'development') {
                for (var messageId in m) {
                    if (messageId in usedIds) {
                        throw new Error("Message ID \"".concat(messageId, "\" may not be used across multiple message ") +
                            'types when calling `declareFeatureMessages()`. See the associated ' +
                            'stack trace to identify the calling feature.');
                    }
                    usedIds[Number(messageId)] = null;
                }
            }
            objectAssign(messages, (_a = {}, _a[messageType] = m, _a));
            return builder;
        };
    };
    var builder = {
        infos: createMessageAssignerOfType(MessageType.INFO),
        logs: createMessageAssignerOfType(MessageType.LOG),
        warnings: createMessageAssignerOfType(MessageType.WARNING),
        errors: createMessageAssignerOfType(MessageType.ERROR),
        messages: messages,
    };
    return builder;
};
export { declareFeatureMessages };
//# sourceMappingURL=declareFeatureMessages.js.map